import type React from 'react';
import type { ReactNode, FC } from 'react';

import { Text, TextType } from 'ui-components/components/text';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';

import { RecommendedIndicator } from '../recommended-indicator';
import type { MessageDescriptor } from 'react-intl';
import { RequiredIndicator } from '../required-indicator';

type CustomsFieldProps = {
  label: MessageDescriptor;
  children: ReactNode;
  recommended?: boolean;
  required?: boolean;
  tooltip?: ReactNode;
  labelClassname?: string;
};

export const CustomsField: FC<CustomsFieldProps> = ({
  label,
  children,
  tooltip,
  recommended = false,
  required = false,
  labelClassname,
}) => {
  return (
    <FlexColumn>
      <FlexRow className={labelClassname} gap={Gap.Space4}>
        <Text textType={TextType.Label} value={label} />
        {recommended && <RecommendedIndicator />}
        {required && <RequiredIndicator />}
        {tooltip}
      </FlexRow>
      {children}
    </FlexColumn>
  );
};
